import React from 'react';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { sequenceTabUrl } from 'constants/routing';

const withGotoSettingsModal = WrappedComponent => (
  class extends React.Component {
    constructor(props) {
      super(props);
      this.toggleConfirmGoToSettingsModal = this.toggleConfirmGoToSettingsModal.bind(this);
      this.goToSettings = this.goToSettings.bind(this);
      this.state = {
        isConfirmGoToSettingsModalOpen: false,
        sequence: null,
      };
    }

    toggleConfirmGoToSettingsModal = sequence => (
      this.setState({
        isConfirmGoToSettingsModalOpen: !this.state.isConfirmGoToSettingsModalOpen,
        sequence,
      })
    );

    goToSettings = () => {
      this.toggleConfirmGoToSettingsModal();
      this.props.history.push({
        pathname: sequenceTabUrl(this.state.sequence.id),
        search: 'open=settings',
      });
    };

    render() {
      return (
        <>
          <WrappedComponent toggleConfirmGoToSettingsModal={this.toggleConfirmGoToSettingsModal} {...this.props} />
          <ConfirmationModal
            open={this.state.isConfirmGoToSettingsModalOpen}
            onCancelClick={this.toggleConfirmGoToSettingsModal}
            confirmLabel="Go to settings"
            confirmBtnColor="primary"
            onConfirmClick={this.goToSettings}
          >
            Please set a launch date and schedule to launch your campaign.
          </ConfirmationModal>
        </>
      );
    }
  }
);

export default withGotoSettingsModal;
